import { MOBILE_SCREEN_QUERY } from "./shared.525ab500164c.js";
const elementTagName = "dialog-backdrop-closer";

export class DialogBackdropCloser extends HTMLElement {
  dialog = null;
  observer = null;

  constructor() {
    super();
  }

  connectedCallback() {
    this.dialog = this.querySelector("dialog");
    if (!this.dialog) {
      console.warn(`No <dialog> found inside <${elementTagName}>`);
      return;
    }

    // Attach click handler for backdrop detection
    this.dialog.addEventListener("click", this.handleDialogClick);

    // Synchronize an Escape key handler with the modal's open attribute
    this.observer = new MutationObserver(this.onDialogStateChange);
    this.observer.observe(this.dialog, {
      attributes: true,
      attributeFilter: ["open"],
    });
    if (this.dialog.hasAttribute("open")) {
      this.attachEscapeHandler();
    }
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
    this.detachEscapeHandler();
  }

  onDialogStateChange = (mutationsList) => {
    for (let mutation of mutationsList) {
      if (mutation.attributeName === "open") {
        if (this.dialog.hasAttribute("open")) {
          this.attachEscapeHandler();
        } else {
          this.detachEscapeHandler();
        }
      }
    }
  };

  handleDialogClick = (event) => {
    if (!MOBILE_SCREEN_QUERY.matches && event.target === this.dialog) {
      this.handleBackdropClick(event);
    } else {
      event.stopPropagation();
    }
  };

  handleBackdropClick = () => {
    this.close();
  };

  attachEscapeHandler = () => {
    document.addEventListener("keydown", this.handleEscapePress);
  };

  detachEscapeHandler = () => {
    document.removeEventListener("keydown", this.handleEscapePress);
  };

  handleEscapePress = (event) => {
    if (event.key === "Escape") {
      this.close();
    }
  };

  close() {
    this.dialog.close();
  }
}

customElements.define(elementTagName, DialogBackdropCloser);
